export default "__VITE_ASSET__CvAocxkm__"